module.exports = __webpack_public_path__ + "img/alexis-franklin-untitled.a08fd9e.jpg";